import { store } from '../store'

export const determineSideNavVisibility = (to) => {
  if (to.matched.some(record => record.meta.showSideNav)) {
    store.dispatch('toggleSideNav', true)
  } else if (to.matched.length > 0) {
    // don't hide the sidebar if between routes and have not yet matched
    store.dispatch('toggleSideNav', false)
  }
}
